import { Recommendations } from "../../components/Recommendations";
import {
  getInsuranceAdvisorData,
  InsuranceAdvisorProvider,
} from "../../contexts";
import { getPropsByName } from "../../utils";
import { Page, PageProviders } from "../Page";
import type { PageProps, WithMetadata } from "../Page/types";
import type { RecommendationsPageProps, RecommendationsProps } from "./types";

const RecommendationsPageInner = (props: RecommendationsPageProps) => {
  const {
    layout: { components },
    configuration,
  } = props;

  const recommendationsProps = getPropsByName({
    name: "recommendations",
    components,
  }) as WithMetadata<RecommendationsProps>;
  if (recommendationsProps) {
    return (
      <Recommendations
        {...recommendationsProps}
        // TODO: Remove fallbacks once backend provides these values
        pageName={configuration.pageName ?? "Recommendations"}
        pageIndex={Number(configuration.pageIndex) || 3}
        sectionName={
          configuration.sectionName ??
          "We recommend this coverage based on what you told us"
        }
      />
    );
  }

  return null;
};

export const RecommendationsPage = (props: RecommendationsPageProps) => {
  const insuranceAdvisorData = getInsuranceAdvisorData(props as PageProps);

  return (
    <PageProviders {...(props as PageProps)}>
      <InsuranceAdvisorProvider insuranceAdvisorData={insuranceAdvisorData}>
        <Page {...(props as PageProps)}>
          <main className="mobius mobius-page__main">
            <RecommendationsPageInner {...props} />
          </main>
        </Page>
      </InsuranceAdvisorProvider>
    </PageProviders>
  );
};
